<template>
  <div>
    <form autocomplete="off">
      <div class="bg-white"></div>
      <div v-if="step == 1" class="style-ordering common-flex">
        <div class="style-image-container">
          <Carousel autoplay v-model="carouselValue" class="details-b-img">
            <CarouselItem v-for="(item, index) in detailsMsg.imageList" :key="index">
              <img 
                @error="errorImg($event)" 
                @load="onImageLoaded(index)" 
                class="details-b-img" 
                :src="item" 
                alt="详情图"
              />
              <div class="image-loading" v-if="!imageLoaded[index]">
                <Spin size="large"></Spin>
              </div>
            </CarouselItem>
          </Carousel>
          <div class="details-img-list">
            <div 
              class="thumb-container" 
              @click="changeImg(index)"
              v-for="(item, index) in detailsMsg.imageList" 
              :key="index"
              :class="carouselValue == index ? 'img-list-select' : 'img-list-fff'"
            >
              <img 
                class="details-s-img" 
                :src="item" 
                alt="详情图"
                @error="errorImg($event)"
              />
            </div>
          </div>
        </div>
        <div class="ordering-right">
          <div class="pro-name">{{ detailsMsg.styleName }}</div>
          <div class="pro-subtitle">{{ $t('styleOrdering.deliveryTime') }}：{{ detailsMsg.deliveryDays }}
            {{ $t('styleOrdering.day') }}
          </div>
          <div class="pro-price" v-if="fabricPrice">{{ fabricPrice }}</div>
          <div class="pro-price-line"></div>
          
          <!-- 面料 -->
          <div class="content-item common-flex common-justify-between common-align-center fabric-section">
            <div class="section-label">Fabric</div>
            <div v-if="detailsMsg.chooseFabric > 0">
              <Select 
                class="fabric-select" 
                v-model="detailsMsg.model" 
                clearable 
                filterable 
                allow-create
                @on-create="(val) => { detailsMsg.fabricList.push(val) }"
              >
                <Option 
                  v-for="(pitem, pindex) in detailsMsg.fabricList" 
                  :value="pitem" 
                  :key="pindex"
                >
                  {{ pitem }}
                </Option>
              </Select>
            </div>
            <div v-else>
              <Input 
                v-model="detailsMsg.model" 
                class="fabric-input ipt-box"
              ></Input>
            </div>
          </div>
          
          <!-- 样式选项 -->
          <Collapse 
            v-model="collapseBox" 
            simple 
            class="collapse-panel"
            v-for="(item, index) in detailsMsg.styleInfoList" 
            :key="index"
          >
            <Panel :name="index.toString()">
              <div class="pro-btns common-flex common-justify-between common-align-center">
                <div class="pro-btns-name">{{ item.styleName }}</div>
                <a class="panel-toggle" href="javascript:void(0)">
                  {{ $t('styleOrdering.styleNumber') }}：{{ item.styleCode }}
                  <Icon v-if="collapseBox.indexOf(index.toString()) == -1" type="ios-arrow-down"/>
                  <Icon v-else type="ios-arrow-up"/>
                </a>
              </div>
              <div slot="content">
                <div 
                  v-for="(sitem, sindex) in item.styleCraftList" 
                  :key="sindex"
                  class="content-item common-flex common-justify-between common-align-center"
                >
                  <Tooltip placement="top" :disabled="!sitem.imageUrl">
                    <div class="craft-name">
                      {{ sitem.name }} 
                      <span v-if="sitem.price" class="craft-price">
                        ({{ detailsMsg.currency }}{{ sitem.price }})
                      </span>
                    </div>
                    <div slot="content">
                      <img :src="sitem.imageUrl" alt="工艺图" class="tooltip-image">
                    </div>
                  </Tooltip>

                  <div v-if="sitem.type == 2 && sitem.chooseContent">
                    <Select v-model="sitem.model" class="craft-select">
                      <Option 
                        v-for="pitem in sitem.chooseContentList" 
                        :value="pitem"
                        :key="pitem"
                      >
                        {{ pitem }}
                      </Option>
                    </Select>
                  </div>
                  <div v-if="sitem.type == 2 && !sitem.chooseContent">
                    <Input v-model="sitem.model" class="craft-input ipt-box"></Input>
                  </div>
                </div>
              </div>
            </Panel>
          </Collapse>
          
          <Button class="buy-now" @click="buyNow" :loading="loading">
            {{ $t('styleOrdering.buy') }}
          </Button>
          
          <div class="property-section">
            <p class="property-goodDetail" v-html="detailsMsg.property"></p>
          </div>
        </div>
      </div>
      
      <div v-show="step == 2 || step == 3">
        <chooseCustomer 
          ref="chooseCustomers" 
          :step="step" 
          :productMsg="productMsg" 
          @next="next" 
          @back="back"
        >
        </chooseCustomer>
      </div>
    </form>
  </div>
</template>
<script>
import {mapActions} from "vuex";
import chooseCustomer from './chooseCustomer.vue'

let timeOut = null
export default {
  name: 'styleOrdering',
  data() {
    return {
      collapseBox: [],
      step: 1,
      fabric: '',
      fabricPrice: '',
      customer: [],
      loading: false,
      imageLoaded: {},
      productMsg: [{
        id: 2000,
        enName: '西裤',
        name: '西裤',
        chooseStyleId: "",
        sizeList: [],
        standardList: [],
        styleList: [],
      }],
      carouselValue: 0,
      detailsMsg: '',
      productId: '',
      defaultImg: require("../../assets/images/none-img.png"),
    }
  },
  components: {
    chooseCustomer
  },
  mounted() {
    if (this.$route.query.orderId) {
      this.editOrder();
    } else {
      this.productId = this.$route.query.id
      this.goodsDetailStyle(this.$route.query.id)
    }
  },
  watch: {
    "detailsMsg.model": {
      handler(newval) {
        clearTimeout(timeOut)
        timeOut = setTimeout(() => {
          if (newval) {
            this.calculatePrice()
          }
        }, 1000)
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    ...mapActions([
      "getCustAction", //查询客户
      "goodsDetailStyleAction", //客户信息
      "submitStyleAction", //提交
      "editOrderAction", //编辑数据
      "calculatePriceAction", //面料价格
    ]),
    calculatePrice() {
      if (this.detailsMsg.model) {
        this.calculatePriceAction({
          id: this.productId,
          code: this.detailsMsg.model
        }).then(res => {
          if (res.code == 0) {
            this.fabricPrice = res.data
          }
        })
      }
    },
    editOrder() {
      this.loading = true;
      this.editOrderAction({
        orderId: this.$route.query.orderId,
        type:
          this.$route.query.orderType &&
          this.$route.query.orderType === "buyagain"
            ? "buy"
            : "edit",
      }).then(res => {
        this.$refs.chooseCustomers.standard(res.data.styleBasicId)
        this.goodsDetailStyle(res.data.styleBasicId, res.data)
        this.productId = res.data.styleBasicId
      }).finally(() => {
        this.loading = false;
      });
    },
    goodsDetailStyle(id, editMsg) {
      this.loading = true;
      this.goodsDetailStyleAction({id: id}).then(res => {
        this.productMsg = []
        res.data.model = ''
        if (res.data.chooseFabric) {
          res.data.fabricList = res.data.chooseFabric.split(',')
        } else {
          res.data.fabricList = []
        }
        if (res.data.fabricList.indexOf(res.data.fabricCode) == -1) {
          res.data.fabricList = res.data.fabricList.concat([res.data.fabricCode])
        }
        res.data.model = res.data.fabricCode
        res.data.styleInfoList.map(s => {
          s.styleCraftList.map((p) => {
            p.model = ''
            if (p.chooseContent) {
              p.chooseContentList = p.chooseContent.split(',')
            }
          })
          this.productMsg.push({
            id: s.clothCategory,
            enName: s.styleName,
            name: s.styleName,
            chooseStyleId: "",
            sizeList: [],
            standardList: [],
            styleList: [],
          })
        })
        if (editMsg) {
          res.data.model = editMsg.fabric
          editMsg.detailList.map(s => {
            s.craftList.map(c => {
              res.data.styleInfoList.map(r => {
                r.styleCraftList.map(l => {
                  if (l.id == c.craftId) {
                    l.model = c.content
                  }
                })
              })
            })
          })
          if (editMsg.orderInfo) {
            let orderInfo = JSON.parse(editMsg.orderInfo);
            this.productMsg = orderInfo.clothing
            this.$refs.chooseCustomers.setOrderInfo(orderInfo, editMsg)
          }
        }
        this.detailsMsg = res.data
        if (!this.$route.query.orderId) {
          this.$refs.chooseCustomers.setGenderId(res.data)
        }
        this.detailsMsg.imageList = res.data.images.split(',')
        
        // 初始化图片加载状态
        this.detailsMsg.imageList.forEach((_, index) => {
          this.$set(this.imageLoaded, index, false);
        });
        
        this.calculatePrice() // 查询面料价格
      }).finally(() => {
        this.loading = false;
      });
    },
    onImageLoaded(index) {
      this.$nextTick(() => {
        this.$set(this.imageLoaded, index, true);
      });
    },
    next() {
      this.step = 3
    },
    back() {
      this.step--
    },
    buyNow() {
      if (this.detailsMsg.model == '' || this.detailsMsg.model == undefined) {
        this.$Message.error(`Please select fabric`);
        return
      }
      
      for (let i = 0; i < this.detailsMsg.styleInfoList.length; i++) {
        let s = this.detailsMsg.styleInfoList[i]
        for (let o = 0; o < s.styleCraftList.length; o++) {
          let p = s.styleCraftList[o]
          if (p.model == '' && p.type == 2) {
            this.$Message.error(`${p.name} Not filled in`);
            return
          }
        }
      }
      
      this.step = 2
      this.$refs.chooseCustomers.setCategroyMsg(this.detailsMsg)
    },
    errorImg(e) {
      e.target.src = this.defaultImg;
      e.target.onerror = null;
    },
    changeCus(e) {
      this.customer.map((item) => {
        if (e == item.custName) {
          this.chooseCustomer(item);
        }
      });
    },
    handleSearch(e) {
      this.getCustAction({keywords: e}).then((res) => {
        this.customer = res.data;
      });
    },
    changeImg(e) {
      this.carouselValue = e;
    },
  }
}
</script>
<style>
#app {
  background-color: #fff;
}
</style>
<style lang="less" scoped>
.style-ordering {
  max-width: 1440px;
  padding: 40px 40px 10px 40px;
  margin: 0 auto;
  display: flex;
  gap: 60px;

  .style-image-container {
    position: relative;
  }

  .details-img-list {
    margin-top: 20px;
    text-align: left;
    overflow-x: auto;
    width: 620px;
    white-space: nowrap;
    display: flex;
    gap: 16px;
    padding-bottom: 10px;

    &::-webkit-scrollbar {
      height: 6px;
    }
    
    &::-webkit-scrollbar-thumb {
      background-color: rgba(0, 0, 0, 0.2);
      border-radius: 3px;
    }
  }

  .thumb-container {
    display: inline-block;
    cursor: pointer;
    transition: all 0.2s ease;
    
    &:hover {
      transform: translateY(-2px);
    }
  }

  .details-b-img {
    width: 620px;
    height: 760px;
    background: #f8f8f8;
    object-fit: contain;
    border-radius: 4px;
    position: relative;
  }
  
  .image-loading {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(248, 248, 248, 0.7);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1;
  }

  .img-list-fff {
    border: 1px solid #eee;
    border-radius: 4px;
  }

  .img-list-select {
    border: 2px solid #0a4dcc;
    border-radius: 4px;
  }

  .details-s-img {
    width: 100px;
    height: 100px;
    border-radius: 4px;
    display: block;
    object-fit: contain;
  }

  .ordering-right {
    flex: 1;

    .content-item {
      height: 60px;
      margin-top: 20px;
      border-bottom: 1px solid rgba(8, 25, 56, .3);
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .fabric-section {
      margin-bottom: 20px;
      border-bottom: none;
    }
    
    .section-label {
      font-weight: 500;
      color: #081938;
    }
    
    .fabric-select, .craft-select {
      min-width: 180px;
    }
    
    .fabric-input, .craft-input {
      width: 180px;
    }
    
    .craft-name {
      font-size: 14px;
      color: #333;
      
      .craft-price {
        color: #0a4dcc;
      }
    }
    
    .tooltip-image {
      width: 200px;
      border-radius: 4px;
    }

    .pro-name {
      font-weight: 550;
      font-size: 28px;
      color: #081938;
      line-height: 34px;
      text-align: left;
      font-style: normal;
      margin-bottom: 14px;
    }

    .pro-subtitle {
      font-size: 16px;
      color: #666;
      line-height: 22px;
      text-align: left;
      margin-bottom: 20px;
    }

    .pro-price {
      margin-bottom: 10px;
      color: #f5222d;
      text-align: left;
      font-size: 24px;
      font-weight: 500;
    }

    .pro-price-line {
      margin-top: 18px;
      border-bottom: 2px solid rgba(8, 25, 56, .3);
    }

    .pro-btns {
      width: 100%;
      height: 50px;
      border-radius: 4px;
      background-color: #0A4DCC;
      font-size: 16px;
      padding: 0 20px;
      color: #fff;
      margin-bottom: 20px;
      
      .panel-toggle {
        color: #fff;
        transition: all 0.2s ease;
        
        &:hover {
          opacity: 0.9;
        }
      }
    }
    
    .property-section {
      margin-top: 30px;
      padding-bottom: 40px;
    }
  }
}

/deep/ .ivu-collapse {
  border: none;
}

/deep/ .ivu-collapse-header {
  height: 50px !important;
  padding-left: 0 !important;
}

.collapse-panel {
  margin-bottom: 20px;
  border-radius: 4px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);

  /deep/ .ivu-icon-ios-arrow-forward {
    display: none;
  }
}

/deep/ .ivu-collapse-content {
  padding: 10px 20px;
  background-color: #f9f9f9;
}

.order-l-item-ipt {
  background-color: #fff !important;
  width: 200px;

  /deep/ .ivu-input {
    border: none;
    box-shadow: none;
    background-color: #fff !important;
    text-align: right;
  }
}

.buy-now {
  width: 100%;
  height: 50px;
  line-height: 50px;
  border-radius: 4px;
  margin: 40px 0 20px;
  background-color: #081938;
  font-size: 16px;
  color: #fff;
  text-align: center;
  cursor: pointer;
  border: none;
  transition: all 0.3s ease;
  
  &:hover {
    background-color: #0f2b56;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(8, 25, 56, 0.2);
  }
  
  &:active {
    transform: translateY(0);
  }
}

.ipt-box {
  /deep/ .ivu-input {
    text-align: center;
    border-radius: 4px;
  }

  /deep/ .ivu-select-input {
    text-align: center;
  }
}

/deep/ .property-goodDetail {
  /* table 样式 */
  table {
    border-top: 1px solid #ccc;
    border-left: 1px solid #ccc;
    width: 100%;
    margin-top: 15px;
  }
  
  table td,
  table th {
    border-bottom: 1px solid #ccc;
    border-right: 1px solid #ccc;
    padding: 8px 12px;
  }
  
  table th {
    border-bottom: 2px solid #ccc;
    text-align: center;
    background-color: #f8f8f8;
  }

  /* blockquote 样式 */
  blockquote {
    display: block;
    border-left: 8px solid #d0e5f2;
    padding: 5px 10px;
    margin: 10px 0;
    line-height: 1.4;
    font-size: 100%;
    background-color: #f1f1f1;
  }

  /* code 样式 */
  code {
    display: inline-block;
    *display: inline;
    *zoom: 1;
    background-color: #f1f1f1;
    border-radius: 3px;
    padding: 3px 5px;
    margin: 0 3px;
  }
  
  pre code {
    display: block;
  }

  /* ul ol 样式 */
  ul, ol {
    margin: 10px 0 10px 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/styleOrdering/styleOrdering.vue